import {
  Avatar,
  Button,
  Col,
  DatePicker,
  DatePickerProps,
  Divider,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Typography,
  notification,
} from "antd";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { sharedDirectory } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RECEIVE_ACTION_TYPE } from "types/enums/receive-action-type";
import Icons from "assets/icons";
import { medicalExaminationService } from "api";
import "./MainInfo.scss";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import { toOptions } from "../../config";
import dayjs from "dayjs";
import { setAction } from "redux/reducer/receive";
import {
  birthday2Age,
  formatDateOrStringToStringGMT_7,
  isValuable,
  normalizePhoneNumber,
  removeSpaces,
  validatePhoneNumberLength,
} from "helper/common";
import Webcam from "react-webcam";
import Notification from "components/common/notification/notification";
import StepInfo from "./StepInfo/StepInfo";
import { FORMAT_TIME } from "types/enums";
import { fixedTimezone } from "helper/fixedTimezone";

const convertBase64ToBlob = (base64: string): Blob => {
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

const MainInfo = (props) => {
  let currentDate = dayjs();
  let dispatch = useAppDispatch();
  const patientRecord = useAppSelector((state) => state.patientRecord);
  const idPhieuKham = useAppSelector((state) => state.common.idPhieuKham);
  const { form } = props;
  const action = useAppSelector((state) => state.receive);
  const [loading, setLoading] = useState<boolean>(true);
  const [provinces, setProvinces] = useState<any[] | null>(null);
  const [districts, setDistricts] = useState<any[] | null>(null);
  const [selectedDistrict, setSelectedDistrict] = useState<number>(null);
  const [communes, setCommunes] = useState<any[] | null>(null);
  const [fullCommunes, setFullCommunes] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [selectedProvince, setSelectedProvince] = useState<number>(null);
  const [selectedCommune, setSelectedCommune] = useState<number>(null);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [imageId, setImageId] = useState<string | null>(null);
  const [haveImage, setHaveImage] = useState<boolean>(false);
  const tinh = Form.useWatch("tinh", form);
  const huyen = Form.useWatch("huyen", form);
  // const xa = Form.useWatch("xa", form);
  const webcamRef = React.useRef(null);
  const [camera, setCamera] = useState<boolean>(false);
  const [selectedDevice, setSelectedDevice] = React.useState(null);
  const [devices, setDevices] = React.useState([]);
  const [trangThaiPK, setTrangThaiPK] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [typeCapture, setTypeCapture] = useState(0);
  const listCommune = JSON.parse(localStorage.getItem("listCommune"));
  const fetchTrangThaiPK = async () => {
    try {
      setLoading(true);
      let response =
        await medicalExaminationService.getListTrangThaiPhieuKham();
      setTrangThaiPK(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Notification("error", "Lỗi khi lấy danh mục trạng thái phiếu khám!");
    }
  };
  // const handleDevices = React.useCallback(
  //   mediaDevices =>
  //     setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
  //   [setDevices]
  // );

  // React.useEffect(
  //   () => {
  //     try {
  //       navigator.mediaDevices.enumerateDevices().then(handleDevices)
  //       .catch(err => )
  //     } catch (err) {
  //
  //     }
  //   },
  //   [handleDevices]
  // );
  const onPhoneBlur = (e) => {
    const normalizedPhoneNumber = normalizePhoneNumber(e.target.value);
    form.setFieldValue("dienThoai", normalizedPhoneNumber);
  };
  const openCamera = () => {
    setCamera(true);
  };
  const closeCamera = () => {
    setSelectedDevice(null);
    setCamera(false);
    setPreviewImage(null);
  };
  const onPhoneFocus = (e) => {
    form.setFieldValue("dienThoai", removeSpaces(e.target.value));
  };
  const transformCode = (v, namePath) => {
    form.setFieldValue(namePath, String(v).toUpperCase());
  };
  const allowedFileTypes = ["image/png", "image/jpeg", "image/jpg"];
  const maxFileSize = 2 * 1024 * 1024;
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const image = event.target.files[0];
      if (!allowedFileTypes.includes(image.type)) {
        Notification("warning", "Chỉ chấp nhận file PNG, JPG hoặc JPEG");
        return;
      }
      if (image.size > maxFileSize) {
        Notification("warning", "Kích thước file không được vượt quá 2MB");
        return;
      }
      const formData = new FormData();
      formData.append("imageFile", image);
      try {
        const response = await medicalExaminationService.uploadImage(formData);
        if (response.status == 200) {
          setImageId(response.data.imageId);
          setHaveImage(true);
        }
      } catch (err) {
        Notification("error", "Lỗi xảy ra khi tải ảnh lên");
      }
    }
  };
  const removeImage = () => {
    setImageId(null);
    setHaveImage(false);
  };
  const captureImage = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setPreviewImage(imageSrc);
  }, []);

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("imageFile", convertBase64ToBlob(previewImage));
    try {
      const response = await medicalExaminationService.uploadImage(formData);
      if (response.status == 200) {
        setImageId(response.data.imageId);
        setHaveImage(true);
      }
      setPreviewImage(null);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi tải ảnh lên");
    }
    closeCamera();
  };
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const fetchProvinces = async () => {
    try {
      let response = await sharedDirectory.getListProvince();
      setProvinces(response.data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };
  const fetchDistricts = async (provinceId) => {
    if (provinceId) {
      try {
        setLoading(true);
        let response = await sharedDirectory.getListDistrict({
          provinceId: provinceId,
        });
        setDistricts(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    }
  };

  const fetchCommunes = async (districtId) => {
    if (districtId) {
      try {
        setLoading(true);
        let response = await sharedDirectory.getListCommune({
          districtId: districtId,
        });
        setCommunes(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    }
  };

  const onFinish = () => {};
  const onProvinceChange = (e) => {
    setSelectedProvince(e);
    form.setFieldValue("huyen", null);
    form.setFieldValue("xa", null);
    fetchDistricts(e);
  };
  const onDistrictChange = (e) => {
    setSelectedDistrict(e);
    form.setFieldValue("xa", null);
    fetchCommunes(e);
  };
  const onCommuneChange = async (e) => {
    try {
      let response = await sharedDirectory.getAddressByCommune({
        id: e,
      });
      setSelectedProvince(response.districtDto.provinceId);
      setSelectedDistrict(response.districtId);
      setSelectedCommune(response.id);
    } catch (err) {}
  };

  const onPatientIdBlur = async (e) => {
    if (e.target.value === "") {
      return;
    }
    try {
      let response = await medicalExaminationService.getPatientById({
        id: e.target.value,
      });
    } catch (err) {
      if (err.response.status && err.response.status == 400) {
        notification.error({
          message: "Không tìm thấy bệnh nhân với mã số trên",
        });
      } else {
        notification.error({
          message: "Lỗi xảy ra khi lấy thông tin bệnh nhân từ mã bệnh nhân",
        });
      }
    }
  };
  const onPKIdBlur = async (e) => {
    if (e.target.value === "") {
      return;
    }
    try {
      let response = await medicalExaminationService.getPKById({
        id: e.target.value,
      });
      if (response.status && response.status == 200) {
        dispatch(
          setAction({
            actionType: RECEIVE_ACTION_TYPE.EDITPHIEUKHAM,
            dataPassing: response.data,
          })
        );
      }
    } catch (err) {
      if (err.response.status && err.response.status == 400) {
        notification.error({
          message: "Không tìm thấy phiếu khám với mã số trên",
        });
      } else {
        notification.error({
          message: "Lỗi xảy ra khi lấy thông tin phiếu khám từ mã phiếu khám",
        });
      }
      form.setFieldValue("id", null);
    }
  };
  const onDeviceChange = (e) => {
    setSelectedDevice(e);
  };
  const searchCommune = async (name = "") => {
    try {
      let response = await sharedDirectory.searchCommune({
        name: name,
      });
      if (name == "") {
        localStorage.setItem("listCommune", JSON.stringify(response ?? []));
      }
      setFullCommunes(response);
      setCommunes(response);
    } catch (err) {}
  };
  const [isOpenDate, setIsOpenDate] = useState<boolean>(false);
  const ngaySinh = Form.useWatch("ngaySinh", form);
  useMemo(() => {
    form.setFieldValue("tuoi", birthday2Age(ngaySinh));
  }, [ngaySinh]);
  useEffect(() => {
    if (action.actionType === RECEIVE_ACTION_TYPE.EDITPHIEUKHAM) {
      if (action.dataPassing && action.dataPassing.tinh != null) {
        fetchDistricts(action.dataPassing.tinh);
        setSelectedProvince(action.dataPassing.tinh);
      }
      if (action.dataPassing && action.dataPassing.huyen != null) {
        fetchCommunes(action.dataPassing.huyen);
        setSelectedDistrict(action.dataPassing.huyen);
      }
      if (action.dataPassing && action.dataPassing.anh != null) {
        setImageId(action.dataPassing.anh);
        setHaveImage(true);
      } else {
        setImageId(null);
        setHaveImage(false);
      }
    } else if (action.actionType === RECEIVE_ACTION_TYPE.PHIEUKHAMMOI) {
      if (action.dataPassing && action.dataPassing.anh != null) {
        setImageId(action.dataPassing.anh);
        setHaveImage(true);
      } else {
        setImageId(null);
        setHaveImage(false);
      }
      // setHaveImage(false);
      setSelectedProvince(null);
      setSelectedDistrict(null);
      setCommunes(null);
    } else if (action.actionType === RECEIVE_ACTION_TYPE.BENHNHANMOI) {
      form.setFieldValue("maBenhNhan", action.dataPassing.maBenhNhan);
      setImageId(null);
      setHaveImage(false);
      setSelectedProvince(null);
      setSelectedDistrict(null);
    } else if (action.actionType == RECEIVE_ACTION_TYPE.HUYKHAM) {
      setImageId(null);
      setHaveImage(false);
    }
  }, [action]);
  useEffect(() => {
    if (
      !patientRecord.selected &&
      action.actionType === RECEIVE_ACTION_TYPE.NORMAL
    ) {
      setImageId(null);
      setHaveImage(false);
    }
  }, [patientRecord, action]);
  useEffect(() => {
    fetchDistricts(tinh);
  }, [tinh]);
  useEffect(() => {
    fetchCommunes(huyen);
  }, [huyen]);
  useEffect(() => {
    fetchProvinces();

    fetchTrangThaiPK();
  }, []);
  useEffect(() => {
    setFullCommunes(listCommune);
    setCommunes(listCommune);
    if (listCommune?.length) {
    } else {
      searchCommune();
    }
  }, []);
  useEffect(() => {
    if (selectedProvince) {
      form.setFieldValue("tinh", selectedProvince);
      form.setFieldValue("huyen", null);
    } else {
      setCommunes(fullCommunes);
    }
  }, [selectedProvince]);
  useEffect(() => {
    if (selectedDistrict) {
      form.setFieldValue("huyen", selectedDistrict);
    } else {
      setCommunes(fullCommunes);
    }
  }, [selectedDistrict]);

  useEffect(() => {
    if (selectedCommune) {
      form.setFieldValue("xa", selectedCommune);
    } else {
      setCommunes(fullCommunes);
    }
  }, [selectedCommune]);

  useEffect(() => {
    if (imageId && haveImage) form.setFieldValue("anh", imageId);
  }, [imageId, haveImage]);
  const stepRef = useRef<any>();
  useEffect(() => {
    if (isValuable(idPhieuKham)) {
      stepRef.current?.getLichSuPhong(idPhieuKham);
    }
  }, [idPhieuKham]);

  // const onChange: DatePickerProps["onChange"] = (date: any, dateString) => {
  //   console.log("🚀 ~ MainInfo ~ date:", date);
  //   const a = fixedTimezone(date);
  //   console.log("🚀 ~ MainInfo ~ a:", a);
  //   // console.log(dayjs(date).format(FORMAT_TIME.dateTime_2), dateString);
  // };

  return (
    <Row className="main-info">
      <Row>
        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
          <Typography.Text strong>Thông tin chính</Typography.Text>
        </Col>
        <Col xs={24} sm={24} md={24} lg={18} xl={18}>
          {action.actionType !== RECEIVE_ACTION_TYPE.BENHNHANMOI ? (
            <StepInfo ref={stepRef} />
          ) : null}
        </Col>
      </Row>
      <Divider type="horizontal" />
      <Form labelAlign="left" form={form} onFinish={onFinish}>
        <Row gutter={[8, 8]}>
          <Row>
            <Col span={4}>
              <Typography.Text>Ảnh bệnh nhân</Typography.Text>
            </Col>
            <Col span={8}>
              {haveImage ? (
                <Row align={"middle"} style={{ gap: "8px" }}>
                  <Form.Item name="anh">
                    <Image
                      width={200}
                      height={"auto"}
                      src={medicalExaminationService.getImageSrc(imageId)}
                      preview={false}
                    />
                  </Form.Item>
                  <Button
                    icon={<Icons.remove />}
                    danger
                    onClick={removeImage}
                  ></Button>
                </Row>
              ) : (
                <>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUpload}
                    ref={fileInputRef}
                  />
                  <Modal
                    open={camera}
                    centered
                    width={"auto"}
                    closable={false}
                    destroyOnClose
                    footer={[
                      <Space direction="horizontal">
                        <Button
                          key="back"
                          type="primary"
                          danger
                          onClick={closeCamera}
                        >
                          Huỷ
                        </Button>
                        <Button
                          type="primary"
                          key="submit"
                          icon={<Icons.camera />}
                          onClick={captureImage}
                        >
                          Chụp
                        </Button>
                        <Button type="primary" key="save" onClick={handleSave}>
                          Lưu
                        </Button>
                      </Space>,
                    ]}
                  >
                    <Row
                      gutter={[16, 8]}
                      style={{
                        width: "1300px",
                        height: "480px",
                      }}
                    >
                      <Col span={12}>
                        <Webcam
                          audio={false}
                          ref={webcamRef}
                          screenshotFormat="image/jpeg"
                          mirrored
                        />
                      </Col>
                      <Col span={12}>
                        {previewImage ? (
                          <img
                            src={previewImage}
                            alt="Preview"
                            style={{ width: "100%" }}
                          />
                        ) : (
                          <Avatar
                            shape="square"
                            style={{
                              paddingLeft: "20px",
                              width: "640px",
                              height: "480px",
                            }}
                            size={500}
                          />
                        )}
                      </Col>
                    </Row>
                    {/* )} */}
                  </Modal>
                  <Row>
                    <Button
                      className="btn-upload"
                      icon={<Icons.add />}
                      type="dashed"
                      onClick={handleClick}
                      style={{
                        width: "96px",
                      }}
                    ></Button>
                    <Button
                      className="btn-upload"
                      icon={<Icons.camera />}
                      type="dashed"
                      onClick={openCamera}
                      style={{
                        width: "96px",
                      }}
                    ></Button>
                  </Row>
                </>
              )}
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <Typography.Text ellipsis>
                    Trạng thái phiếu khám
                  </Typography.Text>
                }
                name="trangThai"
                labelAlign="left"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <Select
                  className="data-select-field"
                  placeholder="Nhập"
                  disabled={true}
                  options={trangThaiPK.map((it) => ({
                    value: it.id,
                    label: it.tenTTPhieuKham,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>

          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Mã phiếu khám</Typography.Text>}
              name="id"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              // rules={
              //   action.actionType == RECEIVE_ACTION_TYPE.EDITBENHNHAN
              //     ? []
              //     : [{required: true, message: "Mã phiếu khám là bắt buộc"}]
              // }
            >
              <Input
                className="data-input-field"
                placeholder="Nhập"
                onBlur={onPKIdBlur}
                onChange={(e) => transformCode(e.target.value, "id")}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Mã bệnh nhân</Typography.Text>}
              name="maBenhNhan"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              // rules={[{required: true, message: "Mã bệnh nhân là bắt buộc"}]}
            >
              <Input
                className="data-input-field"
                placeholder="Nhập"
                onBlur={onPatientIdBlur}
                onChange={(e) => transformCode(e.target.value, "maBenhNhan")}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Họ tên</Typography.Text>}
              name="hoTen"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              rules={[{ required: true, message: "Họ tên là bắt buộc" }]}
            >
              <Input className="data-input-field" placeholder="Nhập" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <Form.Item
              label={<Typography.Text ellipsis>Ngày sinh</Typography.Text>}
              name="ngaySinh"
              labelAlign="left"
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 12 }}
              rules={[{ required: true, message: "Ngày sinh là bắt buộc" }]}
            >
              <DatePicker
                className="data-picker-field"
                placeholder="DD/MM/YYYY"
                format={isOpenDate ? "DDMMYYYY" : "DD/MM/YYYY"}
                onOpenChange={() => setIsOpenDate(!isOpenDate)}
                disabledDate={(current) => current.isAfter(dayjs())}
                onChange={(e) => {}}
              ></DatePicker>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={4} xl={4}>
            <Form.Item
              label={<Typography.Text>Tuổi</Typography.Text>}
              name="tuoi"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
            >
              <Input
                className="data-input-field"
                placeholder="Nhập"
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Giới tính</Typography.Text>}
              name="gioiTinh"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              rules={[{ required: true, message: "Giới tính là bắt buộc" }]}
            >
              <Select
                className="data-select-field"
                placeholder="Chọn"
                options={gioiTinhOptions.filter((it) => it.value !== null)}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Điện thoại</Typography.Text>}
              name="dienThoai"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              rules={[
                {
                  // validator: validatePhoneNumberLength,
                  required: true,
                  message: "Chưa nhập điện thoại hoặc nhập 0000000000",
                },
              ]}
            >
              <Input
                className="data-input-field"
                placeholder="Nhập"
                onBlur={onPhoneBlur}
                onFocus={onPhoneFocus}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Tỉnh</Typography.Text>}
              name="tinh"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              rules={[
                {
                  required: true,
                  message: "Chưa nhập tỉnh",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                className="data-select-field"
                placeholder="Chọn"
                allowClear={true}
                options={provinces ? toOptions(provinces) : []}
                onChange={onProvinceChange}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Huyện</Typography.Text>}
              name="huyen"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              rules={[
                {
                  required: true,
                  message: "Chưa nhập huyện",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                className="data-select-field"
                placeholder="Chọn"
                allowClear
                options={districts ? toOptions(districts) : []}
                onChange={onDistrictChange}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Xã</Typography.Text>}
              name="xa"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              rules={[
                {
                  required: true,
                  message: "Chưa nhập xã",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                className="data-select-field"
                placeholder="Chọn"
                allowClear
                options={communes ? toOptions(communes) : []}
                onChange={onCommuneChange}
                onSearch={(e) => {
                  searchCommune(e);
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Địa chỉ</Typography.Text>}
              name="diaChi"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
            >
              <Input className="data-input-field" placeholder="Nhập" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Email</Typography.Text>}
              name="email"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              rules={[
                {
                  required: false,
                  max: 255,
                  message: "Email gồm tối đa 255 ký tự!",
                },
              ]}
            >
              <Input className="data-input-field" placeholder="Nhập" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Form.Item
              label={<Typography.Text ellipsis>Mã BN cũ</Typography.Text>}
              name="maBNCu"
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
            >
              <Input className="data-input-field" placeholder="Nhập" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Row>
  );
};

export default MainInfo;
